import { useCallback, useState } from "react";

import { GitFork } from "lucide-react";
import { Button, DefaultTooltip, DefaultSheet } from "twyne-new.ui"

import { VersionProvider } from "../store";

import Content from "./Content";

function Modal({ loading, ...props }) {
  const [open, setOpen] = useState(false)

  const onOpenChange = useCallback(open => {
    if (loading) return;
    setOpen(open)
  }, [loading])

  return <DefaultSheet title="See versions" contentProps={{ size: 'lg' }}
    wrapperProps={{ open, onOpenChange }} trigger={<Trigger loading={loading} />}>
    <Content loading={loading} onClose={() => setOpen(false)} {...props} />
  </DefaultSheet>
}

function Trigger({ loading }) {
  return <DefaultTooltip content="Release versions">
    <Button className="items-center" color="accent" variant="ghost" disabled={loading}>
      <GitFork size={16} />
    </Button>
  </DefaultTooltip>
}

export default function DefaultVersionModal(props) {
  return <VersionProvider>
    <Modal {...props} />
  </VersionProvider>
}
